import { render, staticRenderFns } from "./Badges_Category.vue?vue&type=template&id=2afac099&scoped=true&"
import script from "./Badges_Category.vue?vue&type=script&lang=js&"
export * from "./Badges_Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afac099",
  null
  
)

export default component.exports